<template>
    <el-main>
        <div class="breadcrumb-container">
            <el-breadcrumb separator-class="el-icon-arrow-right">
                <el-breadcrumb-item>User Management</el-breadcrumb-item>
                <el-breadcrumb-item>Roles</el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        <el-row style="margin-top: 24px">
            <el-col :span="18">
                <div class="main-title">
                    Role List
                </div>
            </el-col>
            <el-col :span="6" class="text-right">
                <el-button type="primary" size="small" icon="el-icon-plus" @click="$router.push({ name: 'ManageRole'})">New Role</el-button>
            </el-col>
        </el-row>

        <el-row type="flex" style="margin-top:24px">
            <el-col :span="24">
                <el-card class="box-card">
                    <el-row style="margin-bottom: 18px" class="text-right" :gutter="15">
                        <el-col :span="4" :offset="16">
                            <status-filter v-model="query.status" @change="queryStatusChanged()"></status-filter>
                        </el-col>
                        <el-col :span="4">
                            <el-input v-model="query.search" size="small" placeholder="Name" class="filter-item" @keyup.enter.native="searchData"/>
                        </el-col>
                    </el-row>

                    <el-table
                            :data="roles"
                            stripe
                            style="width: 100%">
                        <el-table-column
                                prop="id"
                                label="ID">
                        </el-table-column>
                        <el-table-column
                                prop="name"
                                label="Name">
                        </el-table-column>
                        <el-table-column
                                prop="description"
                                label="Description">
                        </el-table-column>
                        <el-table-column
                                prop="active"
                                label="Active"
                                width="180">
                            <template slot-scope="scope">
                                {{scope.row.active}}
                            </template>
                        </el-table-column>
                        <el-table-column label="Actions">
                            <template slot-scope="scope">
                                <el-button size="mini" icon="el-icon-edit" @click="editRole(scope.row.id)"></el-button>
                                
                            </template>
                        </el-table-column>
                    </el-table>

                    <pagination v-show="query.total>0" :total="query.total" :page.sync="query.page" :limit.sync="query.limit" @pagination="loadData" />
                </el-card>
            </el-col>
        </el-row>

    </el-main>
</template>

<script>
import api from "@/services/api/WRCService";
import Pagination from "@/components/Pagination"
import StatusFilter from '@/components/StatusFilter'

export default {
    components: { Pagination, StatusFilter },
    data: function() {
        return {
            roles: [],
            loading: false,
            query: {
                total: 0,
                page: 0,
                limit: 10,
                pageSize: 0,
                search: null,
                status: 'Active'
            }
        }
    },
    methods:{
        editRole : function(roleId) {
            this.$router.push({ name: 'RoleEdit', params: { roleId } })
        },
        loadData(query){
            this.loading = true;

            var active = null

            if (this.query.status === "Active") {
                active = true
            } else if (this.query.status === "Inactive") {
                active = false
            }

            api.getRoles(query.search, {
                page: query.page - 1,
                size: query.limit
            }, active).then(({ data }) => {

                this.roles.splice(0, this.roles.length);
                this.roles.push(...data.data.items);
                this.query.total = data.data.pagination.totalRecords;
            }).catch(() => {}).then(() => {
                this.loading = false;
            });
        },
        searchData() {
            this.query.page = 1;
            this.loadData(this.query)
        },
        queryStatusChanged() {
            this.searchData()
        },
    },
    mounted() {
        this.query.page = 1;
        this.loadData(this.query);
    }
}
</script>
